// Helpers de cor para derivar superfícies, bordas e textos secundários a partir
// das cores da MARCA DO CLIENTE — assim as telas do aluno funcionam tanto em
// tema claro quanto escuro sem precisar de uma paleta fixa.

// Converte hex (#rgb / #rrggbb) em rgba(). Retorna null quando o valor não é um
// hex válido, para quem chama cair num neutro seguro (`|| '#E5E7EB'`).
export const hexToRgba = (hex, alpha) => {
  if (typeof hex !== 'string') return null;
  let h = hex.trim().replace('#', '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (h.length !== 6) return null;
  const n = parseInt(h, 16);
  if (Number.isNaN(n)) return null;
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default { hexToRgba };
